import { authTktState, authVerifiedState, oAuthService } from '@sd/shared';
import { add, isAfter } from 'date-fns';
import { useEffect, useState } from 'react';
import { useRecoilValue, useSetRecoilState } from 'recoil';

export const MINUTES_TO_WAIT = 5;
export const KeepSessionAlive = () => {
  const authVerified = useRecoilValue(authVerifiedState);
  const setAuthTkt = useSetRecoilState(authTktState);
  const [lastCheckedAt, setLastCheckedAt] = useState(new Date());

  useEffect(() => {
    if (authVerified) {
      let alreadyChecked = false;
      const reVerifyAuth = () => {
        if (!alreadyChecked && isAfter(Date.now(), add(lastCheckedAt, { minutes: MINUTES_TO_WAIT }))) {
          alreadyChecked = true;
          // eslint-disable-next-line @typescript-eslint/no-floating-promises
          oAuthService.verifyAuthWithServer().then(response => {
            if (response.authTkt) {
              setAuthTkt(response.authTkt);
            }
            // Only continue the loop if the request succeeded
            setLastCheckedAt(new Date());
          });
        }
      };
      const eventsToListenTo: Array<keyof DocumentEventMap> = ['click', 'keydown'];
      eventsToListenTo.forEach(eventName => document.addEventListener(eventName, reVerifyAuth));

      return () => {
        eventsToListenTo.forEach(eventName => document.removeEventListener(eventName, reVerifyAuth));
      };
    }
  }, [lastCheckedAt, authVerified]);
  return null;
};
